import React, { useEffect, useState } from "react";
import "./Homepage.css";
import Qualification from "../../component/Qualification/Qualification";
// import Skills from "../../component/Skills/Skills";
import Intro from "../../component/Intro/Intro";
import TechSkills from "../../component/Skills/TechSkills";
import { Helmet } from "react-helmet-async";

const Homepage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const elementPosition = document.documentElement.scrollHeight - 100;
      if (scrollPosition > elementPosition) {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      <Helmet>
        <title>Home - King Damian</title>
        <meta name="description" content="Welcome to King Damian Portfolio." />
        <meta property="og:title" content="Home - King Damian" />
        <meta
          property="og:description"
          content="Find out about King Damian's works"
        />
      </Helmet>

      <section className="HomepageBody">
        <section>
          <div id="intro" className={isVisible ? "animated fadeIn" : ""}>
            <Intro />
          </div>

          <div
            id="qualification"
            className={isVisible ? "animated fadeIn" : ""}
          >
            <Qualification />
          </div>
          {/* 
          <div id="skills" className={isVisible ? "animated fadeIn" : ""}>
            <Skills />
          </div> */}

          <div id="skills" className={isVisible ? "animated fadeIn" : ""}>
            <TechSkills />
          </div>
        </section>
      </section>
    </div>
  );
};

export default Homepage;
